export const INVIEW_CSS = `
  [data-string-inview-layer] {
  
  }

  [data-string-offset-outline] {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    box-sizing: border-box;
    // --string-inview-enter-line: rgb(125, 125, 125);
    // border: 1px dashed var(--string-inview-enter-line);
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23333' stroke-width='1' stroke-dasharray='2%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
    will-change: transform, width, height;
  }

  [data-string-offset-outline][data-visible="false"] {
    display: none;
  }

  [data-string-offset-outline][data-inview="true"] {
    border-color: var(--string-inview-enter-line);
  }

  [data-string-offset-connector] {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: auto;
    will-change: transform, width, height;
    cursor: col-resize;
    user-select: none;
    touch-action: none;
  }

  [data-string-offset-connector][data-pointer="coarse"] {
    width: 22px !important;
    margin-left: -4px;
  }

  [data-string-offset-connector]::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 1px;
    pointer-events: none;
    background-repeat: repeat-y;
    background-position: center top;
    background-size: 1px 10px;
  }

  [data-string-offset-connector][data-visible="false"] {
    display: none;
  }

  [data-string-offset-connector="enter"] {
    color: var(--string-dg-color-blue);
  }

  [data-string-offset-connector="enter"]::before {
    background-image: url("data:image/svg+xml,%3csvg width='1' height='10' viewBox='0 0 1 10' xmlns='http://www.w3.org/2000/svg'%3e%3cline x1='0.5' y1='0' x2='0.5' y2='10' stroke='%231f7dff' stroke-width='1' stroke-dasharray='2%2c4' stroke-linecap='square'/%3e%3c/svg%3e");
  }

  [data-string-offset-connector="exit"] {
    color: var(--string-dg-color-red);
  }

  [data-string-offset-connector="exit"]::before {
    background-image: url("data:image/svg+xml,%3csvg width='1' height='10' viewBox='0 0 1 10' xmlns='http://www.w3.org/2000/svg'%3e%3cline x1='0.5' y1='0' x2='0.5' y2='10' stroke='%23e63f3f' stroke-width='1' stroke-dasharray='2%2c4' stroke-linecap='square'/%3e%3c/svg%3e");
  }

  [data-string-offset-edge-marker] {
    position: absolute;
    top: 0;
    left: 0;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    pointer-events: auto;
    z-index: 1;
    padding: 2px 4px;
    border-radius: 0;
    font-size: 8px;
    line-height: 1;
    font-weight: 500;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    white-space: nowrap;
    will-change: transform;
    box-shadow: none;
    cursor: col-resize;
    user-select: none;
    touch-action: none;

  }

  [data-string-offset-edge-marker][data-pointer="coarse"]::before {
    content: "";
    position: absolute;
    inset: -10px;
  }

  [data-string-offset-edge-marker-label] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 8px;
  }

  [data-string-offset-edge-marker]::after {
    content: "";
    display: inline-block;
    width: 9px;
    height: 5px;
    border: 1px solid white;
    border-radius: 2px;
  }

  [data-string-offset-edge-marker][data-viewport-anchor="top"]::after {
    border-top-width: 3px;
  }
  [data-string-offset-edge-marker][data-viewport-anchor="bottom"]::after {
    border-bottom-width: 3px;
  }

  [data-string-offset-edge-marker][data-visible="false"] {
    display: none;
  }

  [data-string-offset-edge-marker="enter"] {
    color: var(--string-dg-color-white);
    background: var(--string-dg-color-blue);
    padding-right: 10px;
    clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 100%, 0 100%);
  }

  [data-string-offset-edge-marker="enter"][data-flip-y="true"] {
    clip-path: polygon(0 0, 100% 0, calc(100% - 10px) 100%, 0 100%);
  }

  [data-string-offset-edge-marker="exit"] {
    color: var(--string-dg-color-white);
    background: var(--string-dg-color-red);
    padding-left: 10px;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 10px 100%);
  }

  [data-string-offset-edge-marker="exit"][data-flip-y="true"] {
    clip-path: polygon(10px 0, 100% 0, 100% 100%, 0 100%);
  }

  [data-string-offset-edge-marker][data-compact="true"] {
    gap: 3px;
    padding-top: 1px;
    padding-bottom: 1px;
    font-size: 7px;
  }

  [data-string-offset-edge-marker][data-compact="true"]::after {
    width: 7px;
    height: 4px;
  }

  [data-string-offset-edge-marker="enter"][data-compact="true"] {
    padding-right: 7px;
    clip-path: polygon(0 0, calc(100% - 7px) 0, 100% 100%, 0 100%);
  }

  [data-string-offset-edge-marker="enter"][data-compact="true"][data-flip-y="true"] {
    clip-path: polygon(0 0, 100% 0, calc(100% - 7px) 100%, 0 100%);
  }

  [data-string-offset-edge-marker="exit"][data-compact="true"] {
    padding-left: 7px;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 7px 100%);
  }

  [data-string-offset-edge-marker="exit"][data-compact="true"][data-flip-y="true"] {
    clip-path: polygon(7px 0, 100% 0, 100% 100%, 0 100%);
  }
`;
